import React from 'react';
import States from './States';

const DocumentStates = () => {
  const urlFragment = 'cus/states';
  return <States urlFragment={urlFragment} />;
};

export default DocumentStates;
